import type { Subscription, SubscriptionStatus } from "~/types/services";

type StateShape = {
  subscriptionStatus: SubscriptionStatus;
  subscription: Subscription;
  userId: number | undefined;
};

export const useUserStore = defineStore("userStore", {
  // FIXME: could be better to change the name into subscriptionStore.
  state: (): StateShape => {
    const subscriptionStatus: Ref<SubscriptionStatus> =
      ref<SubscriptionStatus>("pending");
    const subscription: Ref<Subscription> = ref<Subscription>();

    return {
      subscriptionStatus: subscriptionStatus.value,
      subscription: subscription.value,
      userId: undefined,
    };
  },
  actions: {
    changeSubscriptionStatus(status: SubscriptionStatus) {
      this.subscriptionStatus = status;
    },
    changeSubscription(subscription: Subscription) {
      this.subscription = subscription;
    },
    setUserId(id: number) {
      this.userId = id;
    },
  },
});
